import { type FC } from 'react'
import pluralize from 'pluralize'
import { Button } from '../../components/Button/Button'

export interface RequestedSeatsSummaryProps {
  requestedTotal?: number
  requestedSeats: { advisor?: number; assistant?: number }
  hasError: boolean
  canBuySeats: boolean
  buyDisabled: boolean
  onBuySeats: () => void
}

export const RequestedSeatsSummary: FC<RequestedSeatsSummaryProps> = ({ requestedTotal, requestedSeats, hasError, canBuySeats, buyDisabled, onBuySeats }) => {
  if (hasError || requestedTotal === undefined) {
    return null
  }

  return (
    <div className='d-inline-flex align-items-center gap-3 zocks-bg-color-gray-100 zocks-p-0.75 rounded-3'>
      <div className='d-flex flex-column gap-1'>
        <div className='paragraph-small bold zocks-text-gray-900'>
          {requestedTotal} requested {pluralize('seat', requestedTotal)}
        </div>
        <div className='d-flex zocks-gap-0.75 paragraph-small zocks-text-gray-600'>
          <span>Advisor: {requestedSeats.advisor ?? 0}</span>
          <span>Assistant: {requestedSeats.assistant ?? 0}</span>
        </div>
      </div>
      {canBuySeats ? (
        <Button variant='header' disabled={buyDisabled} onClick={onBuySeats}>
          Buy seats
        </Button>
      ) : null}
    </div>
  )
}
